<div class="resend-description">{{ 'generic.resend_otp_password_captcha_checkbox' | translate }}</div>
<app-recaptcha (data)="finished($event)"/>
